<template>
  <div class="config-page-header">
    <div class="page-header-container">
      <a class="page-back-button" @click="router.back()"></a>
      <h1>{{ title }}</h1>
      <div class="userID">ユーザーID：{{ userID }}</div>
      <div class="button-hamburger" id="hamburger">
        <img
          src="../../assets/images/icon/button_hamburger.svg"
          alt=""
          aria-label="メニューボタン"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onUnmounted, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { setupGlobalNavMenu } from '@/composables/openMainMenu'

//ページごとにタイトルを変更
const router = useRouter()
const route = useRoute()
const title = computed(() => {
  const path = route.path

  switch (true) {
    case path === '/flight-area-empty':
      return '飛行エリア設定確認'

    case path === '/settings':
      return '設定'

    case path === '/drone-info':
      return '機体情報設定'

    case path === '/flight-areas':
      return '飛行エリア設定'

    case path === '/flight-routes':
      return '航路情報設定'

    case path.startsWith('/flight-route-points'):
      return '航路情報設定'

    default:
      return 'ページタイトル'
  }
})

//ユーザ情報取得(ユーザID取得)
const user = useUserStore()
const userID = computed(() => user.userInfo?.login_name ?? '')

let cleanup: (() => void) | undefined
onMounted(() => {
  cleanup = setupGlobalNavMenu()
})

onUnmounted(() => {
  cleanup?.()
})
</script>
